import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_COVER_SETTINGS } from 'editor/components/CoverPage/config';

export default function useCoverSettingComponentStyle() {
    const coverSetting = useSelector(s => s.settingGameStyle?.coverSetting || {});

    return useMemo(() => {
        return {
            ...DEFAULT_COVER_SETTINGS,
            ...coverSetting
        };
    }, [coverSetting]);
}
